import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserInfo, updateOpeningHours } from "../../services/account-setting.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { handleServerValidations } from "../../../../utils/commonfunction";

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export default function EditBusinessHours() {
  const navigate = useNavigate();
  const [businessHours, setBusinessHours] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getUserInfo();
        if (res?.data?.business_hours?.length) {
          setBusinessHours(res.data.business_hours);
        } else {
          // Default hours if not set
          const defaultHours = days.map((day) => ({
            day,
            is_open: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].includes(day),
            open_time: day === "Saturday" ? "10:00" : "09:00",
            close_time: day === "Saturday" ? "16:00" : "18:00",
          }));
          setBusinessHours(defaultHours);
        }
      } catch (err) {
        console.error("Failed to fetch user info", err);
      }
    };

    fetchData();
  }, []);

  const generateTimeOptions = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time24 = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const ampm = hour < 12 ? "AM" : "PM";
        const time12 = `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
        times.push({ value: time24, label: time12 });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  const handleChange = (index, key, value) => {
    const updated = [...businessHours];
    updated[index][key] = value;
    setBusinessHours(updated);
  };

  const handleToggle = (index) => {
    const updated = [...businessHours];
    updated[index].is_open = !updated[index].is_open;

    if (!updated[index].is_open) {
      updated[index].open_time = updated[index].day === "Saturday" ? "10:00" : "09:00";
      updated[index].close_time = updated[index].day === "Saturday" ? "16:00" : "18:00";
    }

    setBusinessHours(updated);
  };

  const handleNext = async () => {
    const hasInvalidTimes = businessHours.some((dayData) => {
      if (!dayData.is_open) return false;
      return dayData.open_time >= dayData.close_time;
    });

    if (hasInvalidTimes) {
      Swal.fire("Invalid Timing", "Please ensure opening times are before closing times for all open days.", "warning");
      return;
    }

    try {
      const response = await updateOpeningHours({ business_hours: businessHours });
      Swal.fire({
        icon: "success",
        text: response.message || "Business hours updated",
        ...SWAL_SETTINGS,
      });
      navigate("/business/account-setting/edit-business-hours");
    } catch (err) {
      Swal.fire({
        icon: "error",
        text: handleServerValidations(err?.response?.data?.message || "Something went wrong"),
        ...SWAL_SETTINGS,
      });
    }
  };

  return (
    <div  className="main-content">
    <div className="customer-part">
      <div className="card-box">
    <div className="container py-5">
      <div className="setup-box mx-auto">
        <h5 className="h4-headline text-center mb-4">Opening Hours</h5>
        <div>
          {businessHours.map((dayData, i) => (
            <div key={dayData.day} className="row align-items-center mb-3">
              <div className="col-3 subtitle-1">{dayData.day}</div>
              <div className="col-2">
                <span className={dayData.is_open ? "text-success" : "text-muted"}>{dayData.is_open ? "Open" : "Closed"}</span>
              </div>
              <div className="col-2">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" checked={dayData.is_open} onChange={() => handleToggle(i)} />
                </div>
              </div>
              {dayData.is_open && (
                <>
                  <div className="col-2">
                    <select className="form-select time-select" value={dayData.open_time} onChange={(e) => handleChange(i, "open_time", e.target.value)}>
                      {timeOptions.map((time) => (
                        <option key={time.value} value={time.value}>
                          {time.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-1 text-center subtitle-1">To</div>
                  <div className="col-2">
                    <select className="form-select time-select" value={dayData.close_time} onChange={(e) => handleChange(i, "close_time", e.target.value)}>
                      {timeOptions.map((time) => (
                        <option key={time.value} value={time.value}>
                          {time.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
          ))}
          <div className="text-center mt-4">
            <button onClick={handleNext} className="btn btn-oring">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
  );
}
